<template lang="pug">
  .admins-dashboard
    v-app
      v-content
        v-tabs(v-model="tab" @change="onChangeTab" active-class="is-active" grow)
          v-tab(key="selfHelpGroups" href="#self-help-groups" @change="getSelfHelpGroups")
            | 居場所
            v-chip.total-count(right small v-if="selfHelpGroups.length > 0") {{ selfHelpGroups.length }}
          v-tab(key="volunteers" href="#volunteers" @change="getVolunteers")
            | ボランティア団体
            v-chip.total-count(right small v-if="volunteers.length > 0") {{ volunteers.length }}
          v-tab(key="users" href="#users" @change="getUsers")
            | ユーザー
            v-chip.total-count(right small v-if="users.length > 0") {{ users.length }}

        v-tabs-items(v-model="tab" v-cloak)
          v-tab-item(key="selfHelpGroups" value="self-help-groups")

            v-data-table.user-list-table(
              :headers="headers.selfHelpGroup"
              :items="selfHelpGroups"
              loading="isLoading"
              disable-pagination
              hide-default-footer
              @click:row="showSelfHelpGroupDetail"
              )
              template(v-slot:item.confirmed_at="{ item }") {{ $date(item.confirmed_at) }}

          v-tab-item(key="volunteer" value="volunteers")

            v-data-table.user-list-table(
              :headers="headers.volunteers"
              :items="volunteers"
              :items-per-page="20"
              loading="isLoading"
              disable-pagination
              hide-default-footer
              @click:row="showVolunteerDetail"
            )

              template(v-slot:item.confirmed_at="{ item }") {{ $date(item.confirmed_at) }}

          v-tab-item(key="users" value="users")

            v-data-table.user-list-table(
              :headers="headers.users"
              :items="users"
              :items-per-page="20"
              loading="isLoading"
              disable-pagination
              hide-default-footer
              @click:row="showUserDetail"
            )

              template(v-slot:item.confirmed_at="{ item }") {{ $date(item.confirmed_at) }}

        v-alert.notification(ref="notification" v-model="isShowNotification" dense tile dismissible :type="notification.type") {{ notification.message }}

</template>

<script type="module">
import {mapState} from 'vuex'

export default {
  data: () => ({
    tab: null,
    headers: {
      selfHelpGroup: [
        {
          text: '居場所名',
          value: 'toujishakai_name',
          sortable: false
        },
        {
          text: '担当者名',
          value: 'tanto_name',
          sortable: false
        },
        {
          text: '登録日',
          width: 140,
          align: 'center',
          value: 'confirmed_at',
          sortable: true
        }
      ],
      volunteers: [
        {
          text: '団体名',
          value: 'volunteer_name',
          sortable: false
        },
        {
          text: '担当者名',
          value: 'tanto_name',
          sortable: false
        },
        {
          text: '登録日',
          width: 140,
          align: 'center',
          value: 'confirmed_at',
          sortable: true
        }
      ],
      users: [
        {
          text: 'ニックネーム',
          value: 'nickname',
          sortable: false
        },
        {
          text: '性別',
          value: 'gender',
          sortable: false
        },
        {
          text: '年代',
          value: 'age',
          sortable: false
        },
        {
          text: '登録日',
          width: 140,
          align: 'center',
          value: 'confirmed_at',
          sortable: true
        }
      ]
    },
    isLoading: true,
    notification: {type: null, message: null},
    isShowNotification: false,
  }),
  computed: {
    selfHelpGroupsTest: (state) => {
      return [...Array(50)].map((_value ,index) => {return ({
        id: index + 1,
        toujishakai_name: `なまえ${index}`,
        created_at: "2019-10-22T15:41:16.000+09:00"
      })})
    },
    ...mapState({
      dashboardTab: state => state.admin.dashboardTab,
      selfHelpGroups: state => state.admin.selfHelpGroups,
      volunteers: state => state.admin.volunteers,
      users: state => state.admin.users
    })
  },
  created() {
    this.tab = this.dashboardTab
    switch (this.dashboardTab) {
      case 'volunteers':
        this.getVolunteers()
        break;
      case 'users':
        this.getUsers()
        break;
      default:
        this.getSelfHelpGroups()
        break;
    }
  },
  methods: {
    showNotification (type, message) {
      this.isShowNotification = true
      this.notification = {type: type, message: message}
    },

    onChangeTab(tabName) {
        this.$store.commit('setDashboardTab', tabName)
    },

    getSelfHelpGroups() {
      this.isLoading = true
      this.$store.dispatch('getSelfHelpGroups')
        .catch(e => this.showNotification("warning", "居場所一覧を取得できませんでした"))
        .finally(() => this.isLoading = false)
    },

    getVolunteers() {
      this.isLoading = true
      this.$store.dispatch('getVolunteers')
        .catch(e => this.showNotification("warning", "ボランティア団体一覧を取得できませんでした"))
        .finally(() => this.isLoading = false)
    },

    getUsers() {
      this.isLoading = true
      this.$store.dispatch('getUsers')
        .catch(e => this.showNotification("warning", "本人一覧を取得できませんでした"))
        .finally(() => this.isLoading = false)
    },

    showSelfHelpGroupDetail(item) {
      window.location = '/admins/users/groups/' + item.id
    },

    showVolunteerDetail(item) {
      window.location = '/admins/users/volunteers/' + item.id
    },

    showUserDetail(item) {
      window.location = '/admins/users/' + item.id
    }
  }
}
</script>

<style>

.user-list-table tbody > tr:hover {
  cursor: pointer;
}

.notification {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  margin-bottom: 0;
}

.total-count {
  margin-left: 0.5em;
}

</style>
